module.exports = __webpack_public_path__ + "img/comedy.a5cc5bb1.svg";